import type { ChangeEvent } from "react";
import Button from "@shared/v2/Button";
import TextComboInput from "@shared/v2/TextComboInput";
import { MagnifyingGlassSolidV6, PlusSolidV6 } from "@shared/v2/Icomoon";
import Loading from "../Goals/components/Loader";
import TemplatesTabs from "./TemplatesTabs";

interface TemplatesToolbarProps {
  search: string;
  onSearchChange: (value: string) => void;
  createLabel: string;
  onCreate: () => void;
  createDisabled?: boolean;
  loading?: boolean;
}

const TemplatesToolbar = ({
  search,
  onSearchChange,
  createLabel,
  onCreate,
  createDisabled = false,
  loading = false,
}: TemplatesToolbarProps) => (
  <div className="tw-relative tw-flex tw-flex-wrap tw-justify-between tw-gap-[24px]">
    <TemplatesTabs />
    {loading && (
      <span className="tw-mx-auto">
        <Loading />
      </span>
    )}
    <div className="tw-flex-1 tw-flex tw-flex-wrap-reverse tw-justify-end tw-items-start tw-gap-[24px]">
      {/* @ts-expect-error props */}
      <TextComboInput
        containerClassName="tw-flex-1 !tw-max-w-[400px]"
        onChange={(e: ChangeEvent<HTMLInputElement>) => onSearchChange(e.target.value)}
        value={search}
        placeholder="Search"
        trailing={<MagnifyingGlassSolidV6 className="tw-text-gray-50" />}
      />
      {/* @ts-expect-error props */}
      <Button
        className="tw-whitespace-nowrap tw-flex tw-justify-center tw-items-center tw-gap-[6px]"
        size="medium"
        disabled={createDisabled}
        onClick={onCreate}
      >
        <PlusSolidV6 />
        {createLabel}
      </Button>
    </div>
  </div>
);

export default TemplatesToolbar;
